import React, { Component, } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import GeoLandings from 'subsys/geo-landings';
import Row, { Col } from 'components/row';
import Container from 'components/container';
import Link from 'components/link';
import Slick from 'components/slick-slider';

import linksBild from '../links';
import StockCard from '../section-stocks/stock-card';

import translates from './render-stocks-i18n.json';

import 'styles/bild/blocks/_block-projects.scss';

const classesBlockPaginator = new Bem('blockProjects');

export function renderStocksLC(
  stocksLC, bemClassesStocks,
  isDesktop, otherPropsLink = {}, inContent = false
) {
  const stocksLCData = get(stocksLC, 'stocksLC.data') || stocksLC;
  if (!stocksLCData || !stocksLCData.length) return null;

  let otherPropsCard = {};
  if (inContent) {
    otherPropsCard = {
      ...otherPropsCard,
      dataMods: { small: true }
    };
  }

  const stocksCards = map(stocksLCData, (item, index) => (
    <StockCard
      key={index}
      object={item}
      {...otherPropsCard}
    />
  ));

  return (
    <Container
      {...bemClassesStocks(inContent ? 'blockStocksLC' : 'stocksLC', null, classesBlockPaginator().className)}
      body
    >
      <Row {...classesBlockPaginator('rowTopic')}>
        <Col allPr={0}><div {...classesBlockPaginator('text', 'h2')}><h2 children={this.i18n('promotionsInNearestNewBuildings')} /></div></Col>
      </Row>
      <div {...classesBlockPaginator('projects')}>
        {isDesktop ? stocksCards : <Slick {...classesBlockPaginator('slider', 'stocksLC')} children={stocksCards} />}
      </div>
      {renderStocksLink.call(this, otherPropsLink)}
    </Container>
  );
}

export function renderStocksLink(otherPropsLink) {
  const { mainMenuBase = {}, bildMainMenuBase } = this.props;

  const stocksLink = !bildMainMenuBase ? (
    <GeoLandings base={mainMenuBase} injectPropName="landingLinks" project="bild">
      <StocksLink
        classes={classesBlockPaginator}
        otherPropsLink={otherPropsLink}
      />
    </GeoLandings>
  ) : (
    <StocksLink
      landingLinks={bildMainMenuBase.data}
      classes={classesBlockPaginator}
      otherPropsLink={otherPropsLink}
    />
  );

  return stocksLink;
}

@I18nHoc(translates)
export class StocksLink extends Component {
  static propTypes = {
    classes: PropTypes.func,
    landingLinks: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]),
    otherPropsLink: PropTypes.shape({})
  };

  render() {
    const { i18n } = this;
    const { classes, otherPropsLink } = this.props;
    let linkProps = get(this.props, 'landingLinks[stocks]');
    if (!linkProps) {
      const index = findIndex(this.props.landingLinks, it => it.content_type === 'stocks');
      linkProps = index > -1 ? this.props.landingLinks[index] : null;
    }

    if (!linkProps) return null;

    return (
      <div {...classes('linkContainer')}>
        <Link
          {...classes('link')}
          builder={linksBild.sectionLanding}
          builderProps={linkProps}
          title={i18n('seeAllPromotions')}
          rel="nofollow"
          {...otherPropsLink}
        >
          <span {...classes('linkContent')}>
            <span {...classes('text', 'link')} children={i18n('seeAllPromotions')} />
          </span>
        </Link>
      </div>
    );
  }
}
